__webpack_require__.p = "https://arine.kz/arine-app/";